export default __webpack_public_path__ + "static/media/next_hover.762bb508.svg";